import React from 'react';
import MaskedInput from 'react-text-mask';
import emailMask from 'text-mask-addons/dist/emailMask';
import { memoize } from '../../utils/mobx/decorators/memoize';
import { Store } from '../../pagepart/store/Store';
import { BasicPortalStructure } from '../../pagepart/layout/BasicPortalStructure';
import { StoreContext } from 'src/pagepart/utils';
import { Env } from '../../env/Env';
import { ServerProps } from '../../pagepart/portal/utils';
import { helper_isValidEmail } from '../../utils/helper/helper_string';
import { prismaService } from '../../server/service/PrismaService';
import { genRandomHex } from '../../utils/helper/helper_crypt';
import { envService, userService } from '../../server';
import { mailService } from '../../server/service/MailService';
import { BasicAuthBox } from '../../pagepart/auth/BasicAuthBox';
import { hostService } from '../../server/service/HostService';
import { request } from 'express';

export async function getServerSideProps(rawContext) {
  const { env, requestEnv } = await Env.forNextContext(rawContext);

  const { post, get } = requestEnv;

  const emailReceiver: string = (post.email as string) || '';
  const isEmailSyntaxValid = helper_isValidEmail(emailReceiver);
  // let isEmailUserExisting: boolean = false;

  const isCreatePasswordDialog = requestEnv.requestData.resolvedUrl.startsWith('/auth/register');

  if (emailReceiver && isEmailSyntaxValid) {
    const token = genRandomHex(30);

    // redirect to login if email does not exist
    /*
    const existingUsers = await userService.getUsersByEmail(emailReceiver);
    if (existingUsers.length > 0) {
      isEmailUserExisting = true;
*/
    await prismaService.master.token.create({
      data: {
        token,
        email: emailReceiver,
        scope: 'recoverpw',
        validUntil: new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 365),
      },
    });

    const html = await mailService.getMailContent('recover', {
      emailReceiver,
      isCreatePasswordDialog,
      link: `https://${hostService.subdomain}.schlaukopf.de/auth/setpw?token=${token}`,
    });

    const sent = await mailService.mailer.sendMail({
      html,
      from: '"Schlaukopf.de" <email@schlaukopf.de>', // sender address
      to: emailReceiver, // list of receivers,
      //   bcc: 'mhicke@gmail.com',
      subject: isCreatePasswordDialog ? 'Passwort für Schlaukopf erstellen' : 'Passwort vergessen?',
    });
  }
  //}

  const wasEmailSent = emailReceiver && isEmailSyntaxValid; // && isEmailUserExisting;

  return {
    props: {
      ...env.transfer,
      emailReceiver,
      wasEmailSent,
      isEmailSyntaxValid,
      //   isEmailUserExisting,
      defaultEmail: get.email || '',
    },
  };
}

class Recover extends React.Component<ServerProps<typeof getServerSideProps>> {
  @memoize
  get store() {
    return Store.forApp(this);
  }

  setupPage(store: Store) {
    const { wasEmailSent } = this.props;
    if (store.requestStore.requestLocation.pathurl.startsWith('/auth/register')) {
      store.portalStore.metaTitle = 'Passwort erstellen';
    } else {
      store.portalStore.metaTitle = 'Passwort vergessen?';
    }
    if (wasEmailSent) {
      store.portalStore.metaTitle = 'E-Mail gesendet!';
    }

    store.portalStore.includeStylesheetOnce('/static/dist7/assets/css/pages/login/classic/login-4.css');
  }

  render() {
    const { emailReceiver, isEmailSyntaxValid, wasEmailSent } = this.props;

    if (wasEmailSent) {
      return (
        <StoreContext.Provider value={this.store}>
          <BasicPortalStructure aside={null} content={<BasicAuthBox>{this.recoverResult}</BasicAuthBox>} />
        </StoreContext.Provider>
      );
    }
    /*
    if (emailReceiver && isEmailSyntaxValid && !isEmailUserExisting) {
      return (
        <StoreContext.Provider value={this.store}>
          <BasicPortalStructure aside={null} content={<BasicAuthBox>{this.notExisting}</BasicAuthBox>} />
        </StoreContext.Provider>
      );
    }
*/
    return (
      <StoreContext.Provider value={this.store}>
        <BasicPortalStructure aside={null} content={<BasicAuthBox>{this.recoverForm}</BasicAuthBox>} />
      </StoreContext.Provider>
    );
  }

  get recoverResult() {
    const { emailReceiver } = this.props;

    return (
      <>
        {/*begin::Login forgot password form*/}
        <div className="login-forgot">
          <div className="mb-10">
            <h3>E-Mail wurde an</h3>

            <h2>{emailReceiver}</h2>
            <h3>gesendet</h3>

            <div className="text-muted font-weight-bold">vor 1 Sekunde</div>
          </div>
          <div className="alert alert-custom alert-primary pulse" role="alert">
            <div className="alert-icon">
              <i className="flaticon-email" />
            </div>
            <div className="alert-text">Klicke den Link in der E-Mail an, um ein neues Passwort für Schlaukopf zu setzen.</div>
          </div>
          <div className="form-group d-flex flex-wrap flex-center mt-10">
            <a href="/auth/recover" id="kt_login_forgot_cancel" className="btn btn-clean font-weight-bold">
              Zurück
            </a>
            <a href="/" id="kt_login_forgot_cancel" className="btn btn-clean font-weight-bold">
              Zur Startseite
            </a>
          </div>
        </div>
        {/*end::Login forgot password form*/}
      </>
    );
  }

  get title() {
    if (this.props.requestData.resolvedUrl.startsWith('/auth/register')) {
      return 'Willkommen bei Schlaukopf';
    }
    return 'Passwort vergessen ?';
  }

  get subTitle() {
    if (this.props.requestData.resolvedUrl.startsWith('/auth/register')) {
      return 'Wie lautet deine E-Mailadresse ?';
    }
    return 'Hier kannst du dein Schlaukopf Passwort zurücksetzen.';
  }

  get buttonText() {
    if (this.props.requestData.resolvedUrl.startsWith('/auth/register')) {
      return 'Passwort erstellen';
    }
    return 'Passwort zurücksetzen';
  }

  get recoverForm() {
    const { isEmailSyntaxValid, defaultEmail } = this.props;

    return (
      <>
        {/*begin::Login forgot password form*/}
        <div className="login-forgot">
          <div className="mb-15">
            <h3>{this.title}</h3>
            <div className="text-muted font-weight-bold">{this.subTitle}</div>
          </div>
          <form className="form" id="kt_login_forgot_form" method="POST">
            <div className="form-group mb-10">
              <MaskedInput
                mask={emailMask}
                defaultValue={defaultEmail}
                name="email"
                placeholder="E-Mailadresse"
                className="form-control form-control-solid h-auto py-4 px-8"
              />
              {isEmailSyntaxValid && <p className="text-danger">Gib eine gültige E-Mailadresse ein.</p>}
            </div>
            <div className="form-group d-flex flex-wrap flex-center mt-10">
              <button id="kt_login_forgot_submit" className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-2">
                {this.buttonText}
              </button>
              {!this.store.requestStore.requestData.isWebviewInApp && (
                <a href="/auth/done" id="kt_login_forgot_cancel" className="btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-2">
                  Abbrechen
                </a>
              )}
            </div>
          </form>
        </div>
        {/*end::Login forgot password form*/}
      </>
    );
  }
  /*
  get notExisting() {
    const { emailReceiver } = this.props;

    return (
      <>
        <div className="alert alert-warning mb-5 p-5" role="alert">
          <h4 className="alert-heading">Die E-Mailadresse ist uns nicht bekannt.</h4>
          <p>Bist du dir sicher, dass du die richtige E-Mailadresse eingegeben hast?</p>
        </div>

        <div className="form-group d-flex flex-wrap flex-center mt-10">
          <a href="/auth/recover" id="kt_login_forgot_cancel" className="btn btn-clean font-weight-bold">
            Zurück
          </a>
          <a href="/" id="kt_login_forgot_cancel" className="btn btn-clean font-weight-bold">
            Zur Startseite
          </a>
        </div>
      </>
    );
  } */
}

export default Recover;
